import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    Typography,
    List,
    ListItemButton,
    ListItemText,
    Breadcrumbs,
    Link as MLink,
    Container,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from "@mui/material";

import { Link } from "react-router-dom";
import '../../App.css'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { axiosInstance } from "../../Api/Axios/axios";
import { endpoints } from "../../Api/EndPoints/endpoints";




const leftMenu = [
    "GROUP PROFILE",
    "COMPANY PROFILE",
    "VISION & MISSION",
    "MANAGEMENT TEAM",
    "ROC COMPLIANCE ANNUAL RETURN",
    "CERTIFICATES",
    "AWARDS AND RECOGNITIONS",
    "RESEARCH AND DEVELOPMENT",
    "QUALITY POLICY",
    "CLIENTELE",



];



const Research = () => {
    const [data, setData] = useState([]);
    const [rocPdf, setRocPdf] = useState("");

    const fetchData = async () => {
        try {
            const res = await axiosInstance.get(endpoints.AboutUs.research)
            setData(res?.data?.data)


            const anualpdfRes = await axiosInstance.get(endpoints.AboutUs.anualRetuns)


            // ROC Annual Return PDF
            const rocPdfUrl = anualpdfRes?.data?.data?.[0]?.roc_pdf || "";
            setRocPdf(rocPdfUrl);
        }
        catch (err) {
            console.log(err)
        }
    }


    useEffect(() => {
        fetchData()
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
    return (
        <Box sx={{ padding: { xs: 2, md: 4 }, mt: "100px" }}>
            <Container maxWidth='xl'>
                {/* Breadcrumb */}
                <Breadcrumbs sx={{ mb: 2, fontSize: "15px" }}>
                    <MLink component={Link} to="/home" underline="hover" color="inherit">
                        Home
                    </MLink>
                    <Typography color="inherit" sx={{ fontSize: "15px" }}>About Us</Typography>

                    <Typography color="text.primary" sx={{ fontSize: "15px" }}>Research & Development</Typography>
                </Breadcrumbs>



                <Grid container spacing={3}>
                    {/* Left Sidebar */}
                    <Grid item size={{ xs: 12, md: 3 }} sx={{ mt: 2 }}>
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: "15px",
                                mb: 2,
                                textTransform: "uppercase",
                                fontFamily: "Roboto"
                            }}
                        >
                            Product & Services
                        </Typography>



                        <List sx={{ border: "1px solid #ddd" }}>
                            {leftMenu.map((item) => {
                                const isActive = item === "RESEARCH AND DEVELOPMENT";

                                // Special case for PDF link
                                if (item === "ROC COMPLIANCE ANNUAL RETURN") {
                                    return (
                                        <ListItemButton
                                            key={item}
                                            component="a"
                                            href={rocPdf || "#"}
                                            target={rocPdf ? "_blank" : undefined}
                                            rel={rocPdf ? "noopener noreferrer" : undefined}
                                            disabled={!rocPdf}
                                            sx={{
                                                borderBottom: "1px solid #eee",
                                                backgroundColor: "transparent",
                                                color: "#000",
                                                "&:hover": {
                                                    backgroundColor: "#f5f5f5"
                                                },
                                                fontFamily: "Roboto",
                                                opacity: rocPdf ? 1 : 0.6,
                                                cursor: rocPdf ? "pointer" : "not-allowed"
                                            }}
                                        >
                                            <ListItemText
                                                primary={item}
                                                primaryTypographyProps={{
                                                    fontSize: "14px",
                                                    fontWeight: 500,
                                                    fontFamily: "Roboto"
                                                }}
                                            />
                                        </ListItemButton>
                                    );
                                }

                                // Default items
                                return (
                                    <ListItemButton
                                        key={item}
                                        component={Link}
                                        to={`/about/${item.toLowerCase().replace(/ /g, "-")}`}
                                        sx={{
                                            borderBottom: "1px solid #eee",
                                            background: isActive
                                                ? "linear-gradient(125deg, #14b91d, #1171b0)"
                                                : "transparent",
                                            color: isActive ? "#fff" : "#000",

                                            "&:hover": {
                                                background: isActive
                                                    ? "linear-gradient(125deg, #14b91d, #1171b0)"
                                                    : "#f5f5f5",
                                            },

                                            fontFamily: "Roboto",
                                        }}
                                    >
                                        <ListItemText
                                            primary={item}
                                            primaryTypographyProps={{
                                                fontSize: "14px",
                                                fontWeight: 500,
                                                fontFamily: "Roboto"
                                            }}
                                        />
                                    </ListItemButton>
                                );
                            })}
                        </List>

                    </Grid>

                    {/* Right Content Section */}
                    <Grid item size={{ xs: 12, md: 9 }} sx={{ mt: 3 }}>




                        {/* Introduction */}


                        <Box sx={{ mt: 3 }}>


                            {/* profile picture box */}

                            <Box sx={{ mt: 4 }}>
                                <Grid
                                    container
                                    spacing={{ xs: 3, lg: 5 }}
                                    alignItems="flex-start"
                                >
                                    {/* Image */}
                                    <Grid
                                        size={{ xs: 12, lg: 5 }}
                                        sx={{
                                            display: "flex",
                                            justifyContent: { xs: "center", lg: "flex-start" },
                                            alignItems: "flex-start",
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={data?.section1_img}
                                            alt="Research & Development"
                                            sx={{
                                                width: "100%",
                                                maxWidth: {
                                                    xs: "420px",
                                                    sm: "450px",
                                                    lg: "380px",
                                                },
                                                height: "auto",
                                                display: "block",
                                                objectFit: "contain",
                                                borderRadius: "6px",
                                            }}
                                        />
                                    </Grid>

                                    {/* Content */}
                                    <Grid
                                        size={{ xs: 12, lg: 7 }}
                                        sx={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: {
                                                    xs: "16px",
                                                    sm: "17px",
                                                    lg: "18px",
                                                },
                                                lineHeight: {
                                                    xs: 1.6,
                                                    lg: 1.7,
                                                },
                                                fontWeight: 400,
                                                color: "#121111",
                                                fontFamily: "Roboto",
                                                width: "100%",
                                                m: 0,
                                            }}
                                            dangerouslySetInnerHTML={{
                                                __html: data?.section1_desc,
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>

                            <Accordion sx={{
                                background: "#fff",
                                boxShadow: "0px 2px 8px rgba(0,0,0,0.10)",
                                borderRadius: "8px",
                                "&:before": { display: "none" },
                                mt: 8
                            }}>
                                <AccordionSummary sx={{
                                    backgroundColor: "#f8f8f8",
                                    borderBottom: "1px solid #eee",
                                    borderRadius: "8px"
                                }} expandIcon={<ExpandMoreIcon sx={{ color: "#c00" }} />}>
                                    <Typography
                                        sx={{
                                            fontSize: { md: "20px", xs: "16px" },
                                            fontWeight: 500,
                                            fontFamily: "Roboto"
                                        }}
                                    >
                                        {data?.section2_title}
                                    </Typography>
                                </AccordionSummary>

                                <AccordionDetails>
                                    {/* CONTENT INSIDE ACCORDION */}
                                    <Typography sx={headingStyle}

                                        dangerouslySetInnerHTML={{ __html: data?.latest_rnd }}>


                                    </Typography>


                                </AccordionDetails>
                            </Accordion>




                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

const headingStyle = {
    fontSize: "16px",
    fontWeight: 400,
    mt: 2,
    mb: 2,
    fontFamily: "Roboto",
    display: "flex",
    alignItems: "center",
    gap: 1,
    px: 2,
    py: 1.5,
    borderTop: "3px solid #e5e5e5",
    borderBottom: "3px solid #e5e5e5",
    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
    borderRadius: "6px",
    background: "#fff"
};

export default Research;
